import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useEffect, useState } from "react";
import fieldStyles from "../../../styles/fieldStyles";
import boxStyles from "../../../styles/boxStyles";

import ApiService from "../../../services/ApiService";
import { useRef } from "react";
import { formatCurrency } from "../../../utils/formatCurrency";

const EstimateImpact = ({
  openSnack,
  showRecordable,
  inputFields,
  setInputFields,
  listDetailEstimateImpact,
  initialValue,
  listEIC,
  children,
  title,
  usedDetailEstimateContent,
  setUsedDetailEstimateContent,
  refreshPotensi,
  status,
}) => {
  // Initialize
  const [refOptions, setRefOptions] = useState(null);
  const [type1, setType1] = useState(null);
  const [type2, setType2] = useState([]);
  const [data2, setData2] = useState({ itemName: "" });

  const [totalEnvKonversi, setTotalEnvKonversi] = useState(0);
  const [totalEnvKonversiV, setTotalEnvKonversiV] = useState(0);
  const [totalAaE, setTotalAaE] = useState(0);
  const [totalAaEV, setTotalAaEV] = useState(0);

  // Fetch Tipe Content Item
  // const [typeContent, setTypeContent] = useState([]);
  const typeContent = useRef([]);
  useEffect(() => {
    const fetchAll = async () => {
      setRefOptions(listEIC);

      try {
        ApiService.getMsTipePekerjaan()
          .then((res) => {
            setType1(res.data.payload);
          })
          .catch((err) => console.log("err", err));

        await Promise.all(
          listEIC.map(
            async (obj) =>
              await ApiService.getEstimateImpactContentItem(
                obj.detailContentEstimateImpactId
              )
                .then((res) => {
                  typeContent.current = [
                    ...typeContent.current,
                    {
                      detailEstimateImpactId: obj.detailEstimateImpactId,
                      detailContentEstimateImpactId:
                        obj.detailContentEstimateImpactId,
                      type: res.data.payload,
                    },
                  ];
                })
                .finally(() => {
                  setIsFetch(false);
                })
          )
        );
      } catch (err) {
        console.log("err", err);
      }
    };

    const calculateTotals = () => {
      let totalReleaseProduct = 0;
      let totalAssetAndEquipment = 0;
      usedDetailEstimateContent.forEach((detailEC) => {
        if (detailEC.detailContentEstimateImpactId == 17) {
          totalReleaseProduct = detailEC.jumlahOrNilaiKerugian;
        } else if (detailEC.detailContentEstimateImpactId == 18) {
          totalAssetAndEquipment = detailEC.jumlahOrNilaiKerugian;
        }
      });
      setTotalEnvKonversi(totalReleaseProduct);
      setTotalAaE(totalAssetAndEquipment);
    };

    const time = setTimeout(() => {
      fetchAll();
      calculateTotals();
      clearTimeout(time);
    }, 500);

    function optCur() {
      if (listDetailEstimateImpact) {
        listDetailEstimateImpact.forEach((item) => {
          options.current[item.detailEstimateImpactId - 1] = {
            detailEstimateImpactId: item.detailEstimateImpactId,
            detailContentEstimateImpactId: -1,
            type: [],
          };
        });
      } else {
        initialValue.listDetailEstimateImpact.forEach((item) => {
          options.current[item.detailEstimateImpactId - 1] = {
            detailEstimateImpactId: item.detailEstimateImpactId,
            detailContentEstimateImpactId: -1,
            type: [],
          };
        });
      }
    }

    // return () => {
    // Jika dari halaman Edit
    console.log("listDetailEstimateImpact", listDetailEstimateImpact);
    if (listDetailEstimateImpact) {
      listDetailEstimateImpact.forEach((item) => {
        tempDetailEstimateContent.current = [
          ...tempDetailEstimateContent.current,
          { idx: item.detailEstimateImpactId },
        ];

        let totalReleaseProduct = usedDetailEstimateContent?.find(
          (item) => item.detailContentEstimateImpactId === 17
        );
        if (totalReleaseProduct !== undefined) {
          setTotalEnvKonversiV(totalReleaseProduct.jumlahOrNilaiKerugian);
          setTotalEnvKonversi(
            (totalReleaseProduct.jumlahOrNilaiKerugian *
              inputFields.staticValueBTR) /
              100
          );
        }

        let totalAssetandEquipment = usedDetailEstimateContent?.find(
          (item) => item.detailContentEstimateImpactId === 18
        );
        if (totalAssetandEquipment !== undefined) {
          setTotalAaEV(item.jumlahOrNilaiKerugian);
          setTotalAaE(
            (item.jumlahOrNilaiKerugian / inputFields.staticValueBTR) * 100
          );
        }
      });
    }
    // Jika dari halaman Create
    else {
      initialValue.listDetailEstimateImpact.forEach((item) => {
        tempDetailEstimateContent.current = [
          ...tempDetailEstimateContent.current,
          { idx: item.detailEstimateImpactId },
        ];
      });
    }

    optCur();
    // };
  }, []);

  // Handle Change
  const handleChangeKeterangan = (idDCEI, idType, e) => {
    let temp = usedDetailEstimateContent.find(
      (item) => item.detailContentEstimateImpactId === idDCEI
    );
    let idx = usedDetailEstimateContent.findIndex(
      (item) => item.detailContentEstimateImpactId === idDCEI
    );

    if (idType !== null) {
      // Jika Health and safety
      if (temp.detailEstimateImpactId === 1) {
        temp = usedDetailEstimateContent.find(
          (item) =>
            item.detailContentEstimateImpactId === idDCEI &&
            item.idTipePekerja === idType
        );
        idx = usedDetailEstimateContent.findIndex(
          (item) =>
            item.detailContentEstimateImpactId === idDCEI &&
            item.idTipePekerja === idType
        );
      }
      // Jika Environtment
      if (temp.detailEstimateImpactId === 2) {
        temp = usedDetailEstimateContent.find(
          (item) =>
            item.detailContentEstimateImpactId === idDCEI &&
            item.estimateImpactContentItemId === idType
        );
        idx = usedDetailEstimateContent.findIndex(
          (item) =>
            item.detailContentEstimateImpactId === idDCEI &&
            item.estimateImpactContentItemId === idType
        );
      }
    }

    const values = [...usedDetailEstimateContent];
    values[idx][e.target.name] = e.target.value;
    setUsedDetailEstimateContent(values);
  };

  const handleChangeInput = async (idDCEI, idType, e) => {
    // Copy
    let newData = usedDetailEstimateContent;
    // Cari index
    let idx = usedDetailEstimateContent.findIndex(
      (item) => item.detailContentEstimateImpactId === idDCEI
    );

    let temp = newData[idx];

    // Jika punya tipe
    if (idType !== null) {
      // Jika Health and safety
      if (temp.detailEstimateImpactId === 1) {
        // Perbarui index
        idx = newData.findIndex(
          (item) =>
            item.detailContentEstimateImpactId === idDCEI &&
            item.idTipePekerja === idType
        );

        console.log("idx", idx);
      } // Jika Environtment
      else if (temp.detailEstimateImpactId === 2) {
        // Perbarui index
        idx = newData.findIndex(
          (item) =>
            item.detailContentEstimateImpactId === idDCEI &&
            item.estimateImpactContentItemId === idType
        );
      }
    }

    // Cek apakah Environtment
    if (temp.detailEstimateImpactId === 2) {
      let totalKonv = 0;
      // Assign value ke newData
      newData[idx].jumlahOrNilaiKerugian = parseInt(e.target.value);
      newData[idx].nilaiKonversi =
        parseInt(e.target.value) * temp.konversiSatuan;

      let respon = await hitungTingkatKeparahan(newData, idx);
      newData[idx].detailContentValueEstimateImpactId =
        respon.idTblDataMstDtlEstimateImpactContentValue;
      newData[idx].tingkatKeparahan = respon.tingkatKeparahan;

      newData
        .filter((item) => item.detailEstimateImpactId === 2)
        .forEach((itm) => (totalKonv += itm.nilaiKonversi));

      totalKonv = Math.ceil(totalKonv);

      setTotalEnvKonversi(totalKonv);
      setTotalEnvKonversiV((totalKonv / inputFields.staticValueBTR) * 100);

      if (totalKonv <= 0) {
        newData = newData.filter(
          (item) => item.detailContentEstimateImpactId !== 17
        );
      } else {
        let idx2 = newData.findIndex(
          (item) => item.detailContentEstimateImpactId === 17
        );

        newData[idx2] = {
          ...newData[idx2],
          jumlahOrNilaiKerugian: totalKonv,
          // jumlahOrNilaiKerugian: (totalKonv / inputFields.staticValueBTR) * 100,
        };
      }
    }
    // Cek apakah Asset and Equipment
    else if (temp.detailEstimateImpactId === 5) {
      let totalAE = 0;
      newData[idx].jumlahOrNilaiKerugian = parseInt(e.target.value);

      let respon = await hitungTingkatKeparahan(newData, idx);
      newData[idx].detailContentValueEstimateImpactId =
        respon.idTblDataMstDtlEstimateImpactContentValue;
      newData[idx].tingkatKeparahan = respon.tingkatKeparahan;

      newData
        .filter((item) => item.detailEstimateImpactId === 5)
        .forEach((itm) => (totalAE += itm.jumlahOrNilaiKerugian));

      totalAE = Math.ceil(totalAE);
      setTotalAaE(totalAE);
      setTotalAaEV((totalAE / inputFields.staticValueBTR) * 100);

      if (totalAE <= 0) {
        newData = newData.filter(
          (item) => item.detailContentEstimateImpactId !== 18
        );
      } else {
        let idx2 = newData.findIndex(
          (item) => item.detailContentEstimateImpactId === 18
        );

        newData[idx2] = {
          ...newData[idx2],
          jumlahOrNilaiKerugian: totalAE,
        };
      }
    } else {
      newData[idx].jumlahOrNilaiKerugian = Math.ceil(e.target.value);

      console.log("newData[idx]", newData[idx]);

      if (temp.isByValue === true) {
        let respon = await hitungTingkatKeparahan(newData, idx);
        newData[idx].detailContentValueEstimateImpactId =
          respon.idTblDataMstDtlEstimateImpactContentValue;
        newData[idx].tingkatKeparahan = respon.tingkatKeparahan;
      }
    }

    // check severity by BTR percentage
    if (
      temp.detailEstimateImpactId === 2 ||
      temp.detailEstimateImpactId === 5
    ) {
      let totalKonv = 0;
      newData
        .filter(
          (item) =>
            item.detailEstimateImpactId === 2 &&
            (item.detailContentEstimateImpactId !== idDCEI ||
              item.estimateImpactContentItemId !== idType)
        )
        .forEach((itm) => (totalKonv += itm.nilaiKonversi));
      let totalAE = 0;
      newData
        .filter((item) => item.detailEstimateImpactId === 5)
        .forEach((itm) => (totalAE += itm.jumlahOrNilaiKerugian));

      totalAE = Math.ceil(totalAE);
      totalKonv = Math.ceil(totalKonv);

      const percentageBTR = (
        ((totalAE + totalKonv) / inputFields.staticValueBTR) *
        100
      ).toFixed(0);

      console.log("test", inputFields.staticValueBTR);

      hitungTingkatKeparahanFI(percentageBTR).then((dataFI) => {
        // data to calculate severity from BTR percentage
        if (dataFI) {
          //assign tingkat keparahan to total env and total assets
          newData = newData.map((dt) => {
            if (dt.detailEstimateImpactId === 3) {
              dt.detailContentValueEstimateImpactId =
                dataFI.idTblDataMstDtlEstimateImpactContentValue;
              dt.tingkatKeparahan = dataFI.tingkatKeparahan;
            }
            return dt;
          });
          setInputFields((oldVal) => ({
            ...oldVal,
            btrRemark: `Financial Impact ${percentageBTR}%BTR`,
          }));
        }
      });
    }
    setUsedDetailEstimateContent(newData);
    // Refresh Potensi
    refreshPotensi(newData);
  };

  // Menyimpan perubahan dropdown
  // {idx, detailEstimateImpactId, id}
  const tempDetailEstimateContent = useRef([]);

  // Menyimpan data pertambahan detail
  // const usedDetailEstimateContent = useRef([]);

  const handleChangeTitle = (e, value) => {
    let temp = tempDetailEstimateContent.current;
    const tempIdx = tempDetailEstimateContent.current.findIndex(
      (item) => item.idx === value.detailEstimateImpactId
    );

    // Set Options to REF
    if (value.detailEstimateImpactId === 2) {
      setType2(
        typeContent.current.find(
          (item) =>
            item.detailContentEstimateImpactId ===
            value.detailContentEstimateImpactId
        ).type
      );
    }
    options.current[value.detailEstimateImpactId - 1] =
      typeContent.current.find(
        (item) =>
          item.detailContentEstimateImpactId ===
          value.detailContentEstimateImpactId
      );

    temp[tempIdx] = {
      ...temp[tempIdx],
      detailContentEstimateImpactId: value.detailContentEstimateImpactId,
    };

    tempDetailEstimateContent.current = temp;
  };
  const handleChangeType = (e, value, idx) => {
    let temp = tempDetailEstimateContent.current;
    const tempIdx = tempDetailEstimateContent.current.findIndex(
      (item) => item.idx === idx
    );

    if (idx === 2) {
      setData2(value);
    }

    temp[tempIdx] = {
      ...temp[tempIdx],
      id: value.id,
    };

    tempDetailEstimateContent.current = temp;
  };

  // Button Tambah
  const handleAdd = (e) => {
    console.log("e", e);
    //INI KLO JALANIN DARI HASIL BUILD, GAK ADA ISINYA
    console.log(tempDetailEstimateContent);
    console.log(tempDetailEstimateContent.current);
    //END

    if (
      !tempDetailEstimateContent.current[e - 1].detailContentEstimateImpactId
    ) {
      openSnack("Choose Detail!");
      return;
    }
    if (e === 1 || e === 2) {
      if (!tempDetailEstimateContent.current[e - 1].id) {
        openSnack("Choose Detail and Type First!");
        return;
      }
    }

    let newData = putDetailById(e);
    let temp = [...usedDetailEstimateContent, newData];

    // Lakukan pengecekan duplikasi
    if (newData.detailEstimateImpactId === 1) {
      if (
        usedDetailEstimateContent.findIndex(
          (item) =>
            item.detailContentEstimateImpactId ===
              newData.detailContentEstimateImpactId &&
            item.idTipePekerja === newData.idTipePekerja
        ) > -1
      ) {
        openSnack(
          "Data sudah pernah diinputkan, silahkan memilih tipe yang berbeda!"
        );
        return;
      }
    } else if (newData.detailEstimateImpactId === 2) {
      if (
        usedDetailEstimateContent.findIndex(
          (item) =>
            item.detailContentEstimateImpactId ===
              newData.detailContentEstimateImpactId &&
            item.estimateImpactContentItemId ===
              newData.estimateImpactContentItemId
        ) > -1
      ) {
        openSnack(
          "Data sudah pernah diinputkan, silahkan memilih tipe yang berbeda!"
        );
        return;
      }
    } else {
      if (
        usedDetailEstimateContent.findIndex(
          (item) =>
            item.detailContentEstimateImpactId ===
            newData.detailContentEstimateImpactId
        ) > -1
      ) {
        openSnack(
          "Data sudah pernah diinputkan, silahkan memilih kategori yang lainnya!"
        );
        return;
      }
    }

    setUsedDetailEstimateContent(temp);

    if (newData.detailEstimateImpactId === 2) {
      if (
        usedDetailEstimateContent.findIndex(
          (item) => item.detailContentEstimateImpactId === 17
        ) === -1
      ) {
        // Cari Berdasarkan ID
        let newDEC = listEIC.find(
          (item) => item.detailContentEstimateImpactId === 17
        );

        // Daftarkan Total Release Product
        // setUsedDetailEstimateContent([...usedDetailEstimateContent, newDEC]);
        setUsedDetailEstimateContent((oldData) => {
          let newData = [...oldData, newDEC];
          return newData;
        });
      }
    }
    if (newData.detailEstimateImpactId === 5) {
      // Jika TotalAssetAndEquipment Tidak ada
      if (
        usedDetailEstimateContent.findIndex(
          (item) => item.detailContentEstimateImpactId === 18
        ) === -1
      ) {
        // Cari Berdasarkan ID
        let newDEC = listEIC.find(
          (item) => item.detailContentEstimateImpactId === 18
        );

        // Daftarkan Total AssetAndEquipment
        setUsedDetailEstimateContent((oldData) => {
          let newData = [...oldData, newDEC];
          return newData;
        });
      }
    }
    // checking severity not by value
    if (
      newData.detailEstimateImpactId === 1 ||
      newData.detailEstimateImpactId === 4 ||
      newData.detailEstimateImpactId === 6
    ) {
      refreshPotensi(usedDetailEstimateContent.concat(temp));
    }
  };
  const handleRemove = (idDCEI, idType) => {
    // Copy
    let newData = usedDetailEstimateContent;
    // Cari index
    let idx = usedDetailEstimateContent.findIndex(
      (item) => item.detailContentEstimateImpactId === idDCEI
    );

    let temp = newData[idx];

    // Jika tidak memiliki tipe ID
    if (idType === null) {
      // Hapus dari yang sudah dipilih
      newData = newData.filter(
        (item) => item.detailContentEstimateImpactId !== idDCEI
      );
    }
    // jika memiliki tipe ID
    else {
      if (newData[idx].detailEstimateImpactId === 1) {
        // Hapus di copy
        newData = newData.filter(
          (item) =>
            item.detailContentEstimateImpactId !== idDCEI ||
            item.idTipePekerja !== idType
        );
      }
      // Jika Environtment
      else if (newData[idx].detailEstimateImpactId === 2) {
        // Hapus di copy
        newData = newData.filter(
          (item) =>
            item.detailContentEstimateImpactId !== idDCEI ||
            item.estimateImpactContentItemId !== idType
        );
      }
    }

    if (temp.detailEstimateImpactId === 2) {
      // Hitung ulang total jumlahOrNilaiKerugian
      let totalKonv = 0;
      newData
        .filter(
          (item) =>
            item.detailEstimateImpactId === 2 &&
            (item.detailContentEstimateImpactId !== idDCEI ||
              item.estimateImpactContentItemId !== idType)
        )
        .forEach((itm) => (totalKonv += itm.nilaiKonversi));

      totalKonv = Math.ceil(totalKonv);

      setTotalEnvKonversi(totalKonv);
      setTotalEnvKonversiV((totalKonv / inputFields.staticValueBTR) * 100);

      if (totalKonv <= 0) {
        newData = newData.filter(
          (item) => item.detailContentEstimateImpactId !== 17
        );
      } else {
        let idx2 = newData.findIndex(
          (item) => item.detailContentEstimateImpactId === 17
        );

        newData[idx2] = {
          ...newData[idx2],
          jumlahOrNilaiKerugian: totalKonv,
          // jumlahOrNilaiKerugian: (totalKonv / inputFields.staticValueBTR) * 100,
        };
      }
    }
    if (temp.detailEstimateImpactId === 5) {
      // Hitung ulang total jumlahOrNilaiKerugian
      let totalAE = 0;
      newData
        .filter((item) => item.detailEstimateImpactId === 5)
        .forEach((itm) => (totalAE += itm.jumlahOrNilaiKerugian));

      totalAE = Math.ceil(totalAE);

      setTotalAaE(totalAE);
      setTotalAaEV((totalAE / inputFields.staticValueBTR) * 100);

      if (totalAE <= 0) {
        newData = newData.filter(
          (item) => item.detailContentEstimateImpactId !== 18
        );
      } else {
        let idx2 = newData.findIndex(
          (item) => item.detailContentEstimateImpactId === 18
        );

        newData[idx2] = {
          ...newData[idx2],
          jumlahOrNilaiKerugian: totalAE,
        };
      }
    }
    // check severity by BTR percentage
    if (
      temp.detailEstimateImpactId === 2 ||
      temp.detailEstimateImpactId === 5
    ) {
      let totalKonv = 0;
      newData
        .filter(
          (item) =>
            item.detailEstimateImpactId === 2 &&
            (item.detailContentEstimateImpactId !== idDCEI ||
              item.estimateImpactContentItemId !== idType)
        )
        .forEach((itm) => (totalKonv += itm.nilaiKonversi));
      let totalAE = 0;
      newData
        .filter((item) => item.detailEstimateImpactId === 5)
        .forEach((itm) => (totalAE += itm.jumlahOrNilaiKerugian));

      totalAE = Math.ceil(totalAE);
      totalKonv = Math.ceil(totalKonv);

      const percentageBTR = (
        ((totalAE + totalKonv) / inputFields.staticValueBTR) *
        100
      ).toFixed(0);
      hitungTingkatKeparahanFI(percentageBTR).then((dataFI) => {
        if (dataFI) {
          //assign tingkat keparahan to total env and total assets
          newData = newData.map((dt) => {
            if (dt.detailEstimateImpactId === 3) {
              dt.detailContentValueEstimateImpactId =
                dataFI.idTblDataMstDtlEstimateImpactContentValue;
              dt.tingkatKeparahan = dataFI.tingkatKeparahan;
            }
            return dt;
          });
          setInputFields({
            ...inputFields,
            btrRemark: `Financial Impact ${percentageBTR}%BTR`,
          });
        }
      });
    }

    // Pasangkan data baru
    setUsedDetailEstimateContent(newData);
    refreshPotensi(newData);
  };

  const putDetailById = (id) => {
    let tempDEC = tempDetailEstimateContent.current.find(
      (item) => item.idx === id
    );

    let newDEC = listEIC.find(
      (item) =>
        item.detailContentEstimateImpactId ===
        tempDEC.detailContentEstimateImpactId
    );

    if (tempDEC.idx === 1) {
      let tipePekerja = type1.filter((item) => item.id === tempDEC.id);

      newDEC = {
        ...newDEC,
        idTipePekerja: tipePekerja[0].id,
        tipePekerja: tipePekerja[0].name,
      };

      return newDEC;
    }
    if (tempDEC.idx === 2) {
      let detailType2 = type2.filter((item) => item.id === tempDEC.id);

      newDEC = {
        ...newDEC,
        konversiSatuan: detailType2[0].valueConvertion,
        nilaiKonversi: 0,
        estimateImpactContentItemId: detailType2[0].id,
        estimateImpactContentItemName: detailType2[0].itemName,
      };

      return newDEC;
    }

    return newDEC;
  };

  // Fetch tingkat keparahan
  const hitungTingkatKeparahan = async (data, idx) => {
    let respond;

    await ApiService.getTingkatKeparahanByValue({
      IdMstDetailEstimateImpact: data[idx]["detailEstimateImpactId"],
      ContectValue: data[idx]["jumlahOrNilaiKerugian"],
    })
      .then((res) => {
        respond = res.data.payload;
      })
      .catch((error) => console.log("error", error));

    return respond;
  };

  // Fetch tingkat keparahan for FinancialImpact
  const hitungTingkatKeparahanFI = async (percentageBTR) => {
    try {
      const response = await ApiService.getTingkatKeparahanByValue({
        IdMstDetailEstimateImpact: 3,
        ContectValue: percentageBTR,
      });
      return response.data.payload;
    } catch (error) {
      console.log("fetch keparahan FinancialImpact", error);
      return null;
    }
  };

  // Delayed Render
  const [isFetch, setIsFetch] = useState(true);
  const [isDelayed, setIsDelayed] = useState(true);
  useEffect(() => {
    const delay = setTimeout(() => {
      setIsDelayed(false);
      console.log("initial", initialValue);
      clearTimeout(delay);
    }, 500);
  }, []);

  // Async Autocomplete
  const options = useRef([]);

  return (
    <div>
      {!isDelayed && !isFetch && (
        <Box component="div" sx={boxStyles}>
          <center>
            <h3>{title.toUpperCase()}</h3>
          </center>

          {/* <Button
            onClick={() => {
              console.log(
                "usedDetailEstimateContent",
                usedDetailEstimateContent
              );
              console.log("listEIC", listEIC);
            }}
          >
            LOG
          </Button> */}

          {/* Pakai Initial Value */}
          {initialValue.listDetailEstimateImpact
            ? initialValue.listDetailEstimateImpact?.map((item) => (
                <div key={item.detailEstimateImpactId}>
                  {/* Judul Tiap Field */}
                  <h4>{item.nama}</h4>
                  {refOptions !== null && !isFetch && (
                    <Box component="div" sx={fieldStyles}>
                      <Grid container rowGap={1} columnGap={1}>
                        {/* Pilihan Detail */}
                        {item.detailEstimateImpactId !== 3 && (
                          <Grid item xl={4} lg={5} sm={12} xs={12}>
                            <FormControl fullWidth>
                              <Autocomplete
                                name={`listDetail-${item.kode}`}
                                onChange={(e, value) =>
                                  handleChangeTitle(e, value)
                                }
                                required
                                getOptionLabel={(option) =>
                                  option.detailContentEstimateImpactName
                                }
                                options={refOptions.filter(
                                  (eic) =>
                                    eic.detailEstimateImpactId ===
                                    item.detailEstimateImpactId
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={`Choose ${item.nama}`}
                                  />
                                )}
                                getOptionSelected={(option, value) =>
                                  option.detailContentEstimateImpactName ===
                                  value.detailContentEstimateImpactName
                                }
                                disabled={status === "issued"}
                              />
                            </FormControl>
                          </Grid>
                        )}

                        {/* Pilihat tipe id 1 */}
                        {item.detailEstimateImpactId === 1 && (
                          <Grid item xl={4} lg={5} sm={12} xs={12}>
                            <Autocomplete
                              name={`listDetail2-${item.kode}`}
                              onChange={(e, value) =>
                                handleChangeType(
                                  e,
                                  value,
                                  item.detailEstimateImpactId
                                )
                              }
                              required
                              // defaultValue={dataUnit.find(
                              //   (item) => item.id === inputFields.idUnitBisnis
                              // )}
                              getOptionLabel={(option) => option.name}
                              options={type1 ? type1 : []}
                              renderInput={(params) => (
                                <TextField {...params} label={`Choose type`} />
                              )}
                              getOptionSelected={(option, value) =>
                                option.name === value.name
                              }
                              disabled={status === "issued"}
                            />
                          </Grid>
                        )}

                        {/* Pilihan Tipe ID 2 */}
                        {item.detailEstimateImpactId === 2 && (
                          <Grid item xl={4} lg={5} sm={12} xs={12}>
                            <FormControl
                              fullWidth
                              style={{ backgroundColor: "white" }}
                            >
                              <Autocomplete
                                name="tipeDua"
                                onChange={(e, value) =>
                                  handleChangeType(
                                    e,
                                    value,
                                    item.detailEstimateImpactId
                                  )
                                }
                                required
                                value={data2}
                                disabled={
                                  type2.length === 0 || status === "issued"
                                }
                                getOptionLabel={(option) => option.itemName}
                                options={type2}
                                renderInput={(params) => (
                                  <TextField {...params} label="Choose type" />
                                )}
                                getOptionSelected={(option, value) =>
                                  option.itemName === value.itemName
                                }
                              />
                            </FormControl>
                          </Grid>
                        )}

                        {/* Button Tambah */}
                        {item.detailEstimateImpactId !== 3 && (
                          <Grid item xl={3} lg={1} sm={3} xs={12}>
                            <Button
                              variant="contained"
                              sx={{ fontSize: "1.5rem", height: "100%" }}
                              onClick={() =>
                                handleAdd(item.detailEstimateImpactId)
                              }
                              disabled={status === "issued"}
                            >
                              +
                            </Button>
                          </Grid>
                        )}
                      </Grid>

                      {/* List Field Yang tertambah / terpilih*/}
                      {usedDetailEstimateContent?.map(
                        (field, index) =>
                          field.detailEstimateImpactId ===
                            item.detailEstimateImpactId && (
                            <Grid
                              container
                              spacing={0}
                              key={index}
                              sx={{ mt: "15px" }}
                            >
                              {/* List Field id 1 */}
                              {field.detailEstimateImpactId === 1 && (
                                <>
                                  <Grid item xl={3} lg={3} sm={3} xs={12}>
                                    <p>
                                      {field.detailContentEstimateImpactName}
                                    </p>
                                  </Grid>

                                  <Grid item xl={9} lg={9} sm={9} xs={12}>
                                    <Stack spacing={2} direction="row">
                                      <TextField
                                        name="jumlahOrNilaiKerugian"
                                        onChange={(e) => {
                                          // handle max input
                                          if (e.target.value > 999)
                                            e.target.value = 999;
                                          handleChangeInput(
                                            field.detailContentEstimateImpactId,
                                            field.idTipePekerja,
                                            e
                                          );
                                        }}
                                        value={field.jumlahOrNilaiKerugian}
                                        label="Jumlah"
                                        variant="standard"
                                        fullWidth
                                        type="number"
                                        disabled={status === "issued"}
                                      />
                                      {field.satuan !== null && (
                                        <TextField
                                          name="satuan"
                                          value={field.satuan}
                                          label="Satuan"
                                          InputLabelProps={{ shrink: true }}
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled
                                        />
                                      )}
                                      <FormControl variant="standard" fullWidth>
                                        <TextField
                                          name="tipePekerja"
                                          value={field.tipePekerja}
                                          label="Type"
                                          variant="standard"
                                          fullWidth
                                          disabled
                                        />
                                      </FormControl>
                                      <TextField
                                        onChange={(e) =>
                                          handleChangeKeterangan(
                                            field.detailContentEstimateImpactId,
                                            field.idTipePekerja,
                                            e
                                          )
                                        }
                                        value={field.keterangan}
                                        name="keterangan"
                                        label="Keterangan"
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled={status === "issued"}
                                      />
                                      <IconButton
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                        onClick={() =>
                                          handleRemove(
                                            field.detailContentEstimateImpactId,
                                            field.idTipePekerja
                                          )
                                        }
                                        disabled={status === "issued"}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Stack>
                                  </Grid>
                                </>
                              )}

                              {/* List Field id 2 */}
                              {field.detailEstimateImpactId === 2 && (
                                <>
                                  <Grid item xl={1} lg={1} sm={1} xs={12}>
                                    <p>
                                      {field.detailContentEstimateImpactName}
                                    </p>
                                  </Grid>

                                  <Grid item xl={11} lg={11} sm={11} xs={12}>
                                    <Stack spacing={2} direction="row">
                                      <TextField
                                        name="estimateImpactContentItemName"
                                        value={
                                          field.estimateImpactContentItemName
                                        }
                                        label="Type"
                                        variant="standard"
                                        fullWidth
                                        disabled
                                      />
                                      <TextField
                                        name="jumlahOrNilaiKerugian"
                                        onChange={(e) => {
                                          // handle max input
                                          if (e.target.value > 999)
                                            e.target.value = 999;
                                          handleChangeInput(
                                            field.detailContentEstimateImpactId,
                                            field.estimateImpactContentItemId,
                                            e
                                          );
                                        }}
                                        value={field.jumlahOrNilaiKerugian}
                                        label="Jumlah"
                                        variant="standard"
                                        fullWidth
                                        type="number"
                                        disabled={status === "issued"}
                                      />
                                      <TextField
                                        name="satuan"
                                        value={field.satuan}
                                        label="Satuan"
                                        InputLabelProps={{ shrink: true }}
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled
                                      />
                                      <TextField
                                        name="nilai"
                                        value={formatCurrency(
                                          field.konversiSatuan
                                        )}
                                        label="Nilai / Satuan Volume"
                                        InputLabelProps={{ shrink: true }}
                                        variant="standard"
                                        fullWidth
                                        type="number"
                                        // disabled
                                      />
                                      <FormControl variant="standard" fullWidth>
                                        <TextField
                                          name="hasilKonversi"
                                          value={formatCurrency(
                                            field.nilaiKonversi
                                          )}
                                          label="Hasil Konversi"
                                          variant="standard"
                                          fullWidth
                                          disabled
                                        />
                                      </FormControl>
                                      <TextField
                                        onChange={(e) =>
                                          handleChangeKeterangan(
                                            field.detailContentEstimateImpactId,
                                            field.estimateImpactContentItemId,
                                            e
                                          )
                                        }
                                        value={field.keterangan}
                                        name="keterangan"
                                        label="Keterangan"
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled={status === "issued"}
                                      />
                                      <IconButton
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                        onClick={() =>
                                          handleRemove(
                                            field.detailContentEstimateImpactId,
                                            field.estimateImpactContentItemId
                                          )
                                        }
                                        disabled={status === "issued"}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Stack>
                                  </Grid>
                                </>
                              )}

                              {/* List Field id 4 */}
                              {field.detailEstimateImpactId === 4 && (
                                <>
                                  <Grid item xl={3} lg={3} sm={3} xs={12}>
                                    <p>
                                      {field.detailContentEstimateImpactName}
                                    </p>
                                  </Grid>

                                  <Grid item xl={9} lg={9} sm={9} xs={12}>
                                    <Stack spacing={2} direction="row">
                                      <TextField
                                        onChange={(e) =>
                                          handleChangeKeterangan(
                                            field.detailContentEstimateImpactId,
                                            null,
                                            e
                                          )
                                        }
                                        value={field.keterangan}
                                        name="keterangan"
                                        label="Keterangan"
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled={status === "issued"}
                                      />
                                      <IconButton
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                        onClick={() =>
                                          handleRemove(
                                            field.detailContentEstimateImpactId,
                                            null
                                          )
                                        }
                                        disabled={status === "issued"}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Stack>
                                  </Grid>
                                </>
                              )}

                              {/* List Field id 5 */}
                              {field.detailEstimateImpactId === 5 && (
                                <>
                                  <Grid item xl={3} lg={3} sm={3} xs={12}>
                                    <p>
                                      {field.detailContentEstimateImpactName}
                                    </p>
                                  </Grid>

                                  <Grid item xl={9} lg={9} sm={9} xs={12}>
                                    <Stack spacing={2} direction="row">
                                      <TextField
                                        name="jumlahOrNilaiKerugian"
                                        onChange={(e) => {
                                          e.target.value =
                                            e.target.value.replaceAll(".", "");
                                          handleChangeInput(
                                            field.detailContentEstimateImpactId,
                                            null,
                                            e
                                          );
                                        }}
                                        value={formatCurrency(
                                          field.jumlahOrNilaiKerugian
                                        )}
                                        label="Nilai Kerugian"
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled={status === "issued"}
                                      />
                                      <TextField
                                        name="satuan"
                                        value={field.satuan}
                                        label="Satuan"
                                        InputLabelProps={{ shrink: true }}
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled
                                      />
                                      <TextField
                                        onChange={(e) =>
                                          handleChangeKeterangan(
                                            field.detailContentEstimateImpactId,
                                            null,
                                            e
                                          )
                                        }
                                        value={field.keterangan}
                                        name="keterangan"
                                        label="Keterangan"
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled={status === "issued"}
                                      />
                                      <IconButton
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                        onClick={() =>
                                          handleRemove(
                                            field.detailContentEstimateImpactId,
                                            null
                                          )
                                        }
                                        disabled={status === "issued"}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Stack>
                                  </Grid>
                                </>
                              )}

                              {/* List Field id 6 */}
                              {field.detailEstimateImpactId === 6 && (
                                <>
                                  <Grid item xl={3} lg={3} sm={3} xs={12}>
                                    <p>
                                      {field.detailContentEstimateImpactName}
                                    </p>
                                  </Grid>

                                  <Grid item xl={9} lg={9} sm={9} xs={12}>
                                    <Stack spacing={2} direction="row">
                                      <TextField
                                        onChange={(e) =>
                                          handleChangeKeterangan(
                                            field.detailContentEstimateImpactId,
                                            null,
                                            e
                                          )
                                        }
                                        value={field.keterangan}
                                        name="keterangan"
                                        label="Keterangan"
                                        variant="standard"
                                        fullWidth
                                        type="text"
                                        disabled={status === "issued"}
                                      />
                                      <IconButton
                                        color="primary"
                                        aria-label="upload picture"
                                        component="label"
                                        onClick={() =>
                                          handleRemove(
                                            field.detailContentEstimateImpactId,
                                            null
                                          )
                                        }
                                        disabled={status === "issued"}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Stack>
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          )
                      )}

                      {/* Footer Field id 2 */}
                      {item.detailEstimateImpactId === 2 &&
                        totalEnvKonversi > 0 && (
                          <Grid
                            container
                            spacing={0}
                            key={item.detailEstimateImpactId}
                          >
                            <Grid item xl={1} lg={1} sm={1} xs={12}></Grid>

                            <Grid item xl={11} lg={11} sm={11} xs={12}>
                              <Stack spacing={2} direction="row">
                                <div style={{ width: "10%" }}></div>
                                <div style={{ width: "100%" }}></div>
                                <div style={{ width: "100%" }}></div>
                                <div style={{ width: "100%" }}></div>
                                <FormControl variant="standard" fullWidth>
                                  <TextField
                                    name="totalEnvKonversi"
                                    value={formatCurrency(
                                      Number(totalEnvKonversi)
                                    )}
                                    label={
                                      <Typography sx={{ fontWeight: "bold" }}>
                                        Total Konversi
                                      </Typography>
                                    }
                                    inputProps={{
                                      style: { fontWeight: "bold" },
                                    }}
                                    variant="standard"
                                    fullWidth
                                    disabled
                                  />
                                </FormControl>
                                <div style={{ width: "100%" }}></div>
                              </Stack>
                            </Grid>
                          </Grid>
                        )}
                      {/* Footer field id 5 */}
                      {item.detailEstimateImpactId === 5 && totalAaE > 0 && (
                        <Grid
                          container
                          spacing={0}
                          key={item.detailEstimateImpactId}
                        >
                          <Grid item xl={1} lg={1} sm={1} xs={12}></Grid>

                          <Grid item xl={11} lg={11} sm={11} xs={12}>
                            <Stack spacing={2} direction="row">
                              <div style={{ width: "10%" }}></div>
                              <div style={{ width: "100%" }}></div>
                              <div style={{ width: "100%" }}></div>
                              <div style={{ width: "100%" }}></div>
                              <FormControl variant="standard" fullWidth>
                                <TextField
                                  name="totalEnvKonversi"
                                  value={formatCurrency(totalAaE)}
                                  label={
                                    <Typography sx={{ fontWeight: "bold" }}>
                                      Total Konversi
                                    </Typography>
                                  }
                                  inputProps={{
                                    style: { fontWeight: "bold" },
                                  }}
                                  variant="standard"
                                  fullWidth
                                  disabled
                                  style={{ fontWeight: "bold" }}
                                />
                              </FormControl>
                              <div style={{ width: "100%" }}></div>
                            </Stack>
                          </Grid>
                        </Grid>
                      )}
                      {/* Header Field id 3 */}
                      {item.detailEstimateImpactId === 3 &&
                        (totalEnvKonversi > 0 || totalAaE > 0) && (
                          <Grid
                            container
                            spacing={0}
                            key={item.detailEstimateImpactId + "header"}
                            sx={{ fontWeight: "bold" }}
                          >
                            Value BTR USD{" "}
                            {formatCurrency(inputFields.staticValueBTR)}
                          </Grid>
                        )}
                      {/* List Field id 3 */}
                      {item.detailEstimateImpactId === 3 &&
                        usedDetailEstimateContent?.map(
                          (field) =>
                            field.detailEstimateImpactId ===
                              item.detailEstimateImpactId && (
                              <Grid
                                container
                                spacing={0}
                                key={field.detailContentEstimateImpactId}
                              >
                                <Grid item xl={3} lg={3} sm={3} xs={12}>
                                  <p>{field.detailContentEstimateImpactName}</p>
                                </Grid>

                                <Grid item xl={9} lg={9} sm={9} xs={12}>
                                  <Stack spacing={2} direction="row">
                                    <TextField
                                      name="jumlahOrNilaiKerugian"
                                      label="Nilai Kerugian"
                                      value={formatCurrency(
                                        field.jumlahOrNilaiKerugian
                                      )}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      disabled
                                      variant="standard"
                                      fullWidth
                                      type="text"
                                    />
                                    <TextField
                                      name="satuan"
                                      value={field.satuan}
                                      disabled
                                      label="Satuan"
                                      InputLabelProps={{ shrink: true }}
                                      variant="standard"
                                      fullWidth
                                      type="text"
                                    />
                                    <TextField
                                      onChange={(e) =>
                                        handleChangeKeterangan(
                                          field.detailContentEstimateImpactId,
                                          null,
                                          e
                                        )
                                      }
                                      value={field.keterangan}
                                      name="keterangan"
                                      label="Keterangan"
                                      variant="standard"
                                      fullWidth
                                      type="text"
                                      disabled={status === "issued"}
                                    />
                                  </Stack>
                                </Grid>
                              </Grid>
                            )
                        )}

                      {/* Footer Field id 3 */}
                      {item.detailEstimateImpactId === 3 &&
                        (totalEnvKonversi > 0 || totalAaE > 0) && (
                          <Grid
                            container
                            spacing={0}
                            key={item.detailEstimateImpactId}
                          >
                            <Grid
                              item
                              xl={3}
                              lg={3}
                              sm={3}
                              xs={12}
                              sx={{ fontWeight: "bold" }}
                            >
                              Total
                            </Grid>
                            <Grid item xl={9} lg={9} sm={9} xs={12}>
                              <Stack spacing={2} direction="row">
                                <FormControl variant="standard" fullWidth>
                                  <TextField
                                    disabled
                                    value={formatCurrency(
                                      Number(
                                        totalAaE + totalEnvKonversi
                                      ).toFixed(0)
                                    )}
                                    variant="standard"
                                    fullWidth
                                    inputProps={{
                                      style: { fontWeight: "bold" },
                                    }}
                                  />
                                </FormControl>
                                <div style={{ width: "100%" }}></div>
                                <div
                                  style={{ width: "100%", fontWeight: "bold" }}
                                >
                                  Financial Impact ={" "}
                                  {(
                                    ((totalAaE + totalEnvKonversi) /
                                      inputFields.staticValueBTR) *
                                    100
                                  ).toFixed(0)}
                                  % BTR
                                </div>
                              </Stack>
                            </Grid>
                          </Grid>
                        )}
                    </Box>
                  )}
                </div>
              ))
            : listDetailEstimateImpact?.map((item) => (
                <div key={item.detailEstimateImpactId}>
                  {/* Judul Tiap Field */}
                  <h4>{item.nama}</h4>

                  {refOptions !== null && !isFetch && (
                    <Box component="div" sx={fieldStyles}>
                      <Grid container rowGap={1} columnGap={1}>
                        {/* Pilihan Detail */}
                        {item.detailEstimateImpactId !== 3 && (
                          <Grid item xl={4} lg={5} sm={12} xs={12}>
                            <FormControl fullWidth>
                              <Autocomplete
                                name={`listDetail-${item.kode}`}
                                onChange={(e, value) =>
                                  handleChangeTitle(e, value)
                                }
                                required
                                getOptionLabel={(option) =>
                                  option.detailContentEstimateImpactName
                                }
                                options={refOptions.filter(
                                  (eic) =>
                                    eic.detailEstimateImpactId ===
                                    item.detailEstimateImpactId
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={`Choose ${item.nama}`}
                                  />
                                )}
                                getOptionSelected={(option, value) =>
                                  option.detailContentEstimateImpactName ===
                                  value.detailContentEstimateImpactName
                                }
                                disabled={status === "issued"}
                              />
                            </FormControl>
                          </Grid>
                        )}

                        {/* Pilihat tipe id 1 */}
                        {item.detailEstimateImpactId === 1 && (
                          <Grid item xl={4} lg={5} sm={12} xs={12}>
                            <Autocomplete
                              name={`listDetail2-${item.kode}`}
                              onChange={(e, value) =>
                                handleChangeType(
                                  e,
                                  value,
                                  item.detailEstimateImpactId
                                )
                              }
                              required
                              // defaultValue={dataUnit.find(
                              //   (item) => item.id === inputFields.idUnitBisnis
                              // )}
                              getOptionLabel={(option) => option.name}
                              options={type1 ? type1 : []}
                              renderInput={(params) => (
                                <TextField {...params} label={`Choose type`} />
                              )}
                              getOptionSelected={(option, value) =>
                                option.name === value.name
                              }
                              disabled={status === "issued"}
                            />
                          </Grid>
                        )}

                        {/* Pilihan Tipe ID 2 */}
                        {item.detailEstimateImpactId === 2 && (
                          <Grid item xl={4} lg={5} sm={12} xs={12}>
                            <FormControl
                              fullWidth
                              style={{ backgroundColor: "white" }}
                            >
                              <Autocomplete
                                name="tipeDua"
                                onChange={(e, value) =>
                                  handleChangeType(
                                    e,
                                    value,
                                    item.detailEstimateImpactId
                                  )
                                }
                                required
                                value={data2}
                                disabled={
                                  type2.length === 0 || status === "issued"
                                }
                                getOptionLabel={(option) => option.itemName}
                                options={type2}
                                renderInput={(params) => (
                                  <TextField {...params} label="Choose type" />
                                )}
                                getOptionSelected={(option, value) =>
                                  option.itemName === value.itemName
                                }
                              />
                            </FormControl>
                          </Grid>
                        )}

                        {/* Button Tambah */}
                        {item.detailEstimateImpactId !== 3 && (
                          <Grid item xl={3} lg={1} sm={3} xs={12}>
                            <Button
                              variant="contained"
                              sx={{ fontSize: "1.5rem", height: "100%" }}
                              onClick={() =>
                                handleAdd(item.detailEstimateImpactId)
                              }
                              disabled={status === "issued"}
                            >
                              +
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                      {/* List Field Yang tertambah / terpilih*/}
                      {usedDetailEstimateContent !== null &&
                        usedDetailEstimateContent?.map(
                          (field, index) =>
                            field.detailEstimateImpactId ===
                              item.detailEstimateImpactId && (
                              <Grid
                                container
                                spacing={0}
                                key={index}
                                sx={{ mt: "15px" }}
                              >
                                {/* List Field id 1 */}
                                {field.detailEstimateImpactId === 1 && (
                                  <>
                                    <Grid item xl={3} lg={3} sm={3} xs={12}>
                                      <p>
                                        {field.detailContentEstimateImpactName}
                                      </p>
                                    </Grid>

                                    <Grid item xl={9} lg={9} sm={9} xs={12}>
                                      <Stack spacing={2} direction="row">
                                        <TextField
                                          name="jumlahOrNilaiKerugian"
                                          onChange={(e) => {
                                            if (e.target.value > 999)
                                              e.target.value = 999;
                                            handleChangeInput(
                                              field.detailContentEstimateImpactId,
                                              field.idTipePekerja,
                                              e
                                            );
                                          }}
                                          value={field.jumlahOrNilaiKerugian}
                                          label="Jumlah"
                                          variant="standard"
                                          fullWidth
                                          type="number"
                                          disabled={status === "issued"}
                                        />
                                        {field.satuan !== null && (
                                          <TextField
                                            name="satuan"
                                            value={field.satuan}
                                            label="Satuan"
                                            InputLabelProps={{ shrink: true }}
                                            variant="standard"
                                            fullWidth
                                            type="text"
                                            disabled
                                          />
                                        )}
                                        <FormControl
                                          variant="standard"
                                          fullWidth
                                        >
                                          <TextField
                                            name="tipePekerja"
                                            value={field.tipePekerja}
                                            label="Type"
                                            variant="standard"
                                            fullWidth
                                            disabled
                                          />
                                        </FormControl>
                                        <TextField
                                          onChange={(e) =>
                                            handleChangeKeterangan(
                                              field.detailContentEstimateImpactId,
                                              field.idTipePekerja,
                                              e
                                            )
                                          }
                                          value={field.keterangan}
                                          name="keterangan"
                                          label="Keterangan"
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled={status === "issued"}
                                        />
                                        <IconButton
                                          color="primary"
                                          aria-label="upload picture"
                                          component="label"
                                          onClick={() =>
                                            handleRemove(
                                              field.detailContentEstimateImpactId,
                                              field.idTipePekerja
                                            )
                                          }
                                          disabled={status === "issued"}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Stack>
                                    </Grid>
                                  </>
                                )}
                                {/* List Field id 2 */}
                                {field.detailEstimateImpactId === 2 && (
                                  <>
                                    <Grid item xl={1} lg={1} sm={1} xs={12}>
                                      <p>
                                        {field.detailContentEstimateImpactName}
                                      </p>
                                    </Grid>

                                    <Grid item xl={11} lg={11} sm={11} xs={12}>
                                      <Stack spacing={2} direction="row">
                                        <TextField
                                          name="estimateImpactContentItemName"
                                          value={
                                            field.estimateImpactContentItemName
                                          }
                                          label="Type"
                                          variant="standard"
                                          fullWidth
                                          disabled
                                        />
                                        <TextField
                                          name="jumlahOrNilaiKerugian"
                                          onChange={(e) => {
                                            // handle max input
                                            if (e.target.value > 999)
                                              e.target.value = 999;
                                            handleChangeInput(
                                              field.detailContentEstimateImpactId,
                                              field.estimateImpactContentItemId,
                                              e
                                            );
                                          }}
                                          value={field.jumlahOrNilaiKerugian}
                                          label="Jumlah"
                                          variant="standard"
                                          fullWidth
                                          type="number"
                                          disabled={status === "issued"}
                                        />
                                        <TextField
                                          name="satuan"
                                          value={field.satuan}
                                          label="Satuan"
                                          InputLabelProps={{ shrink: true }}
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled
                                        />
                                        <TextField
                                          name="nilai"
                                          value={formatCurrency(
                                            field.konversiSatuan
                                          )}
                                          label="Nilai / Satuan Volume"
                                          InputLabelProps={{ shrink: true }}
                                          variant="standard"
                                          fullWidth
                                          type="number"
                                          // disabled
                                        />
                                        <FormControl
                                          variant="standard"
                                          fullWidth
                                        >
                                          <TextField
                                            name="hasilKonversi"
                                            value={formatCurrency(
                                              field.nilaiKonversi
                                            )}
                                            label="Hasil Konversi"
                                            variant="standard"
                                            fullWidth
                                            disabled
                                          />
                                        </FormControl>
                                        <TextField
                                          onChange={(e) =>
                                            handleChangeKeterangan(
                                              field.detailContentEstimateImpactId,
                                              field.estimateImpactContentItemId,
                                              e
                                            )
                                          }
                                          value={field.keterangan}
                                          name="keterangan"
                                          label="Keterangan"
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled={status === "issued"}
                                        />
                                        <IconButton
                                          color="primary"
                                          aria-label="upload picture"
                                          component="label"
                                          onClick={() =>
                                            handleRemove(
                                              field.detailContentEstimateImpactId,
                                              field.estimateImpactContentItemId
                                            )
                                          }
                                          disabled={status === "issued"}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Stack>
                                    </Grid>
                                  </>
                                )}

                                {/* List Field id 4 */}
                                {field.detailEstimateImpactId === 4 && (
                                  <>
                                    <Grid item xl={3} lg={3} sm={3} xs={12}>
                                      <p>
                                        {field.detailContentEstimateImpactName}
                                      </p>
                                    </Grid>

                                    <Grid item xl={9} lg={9} sm={9} xs={12}>
                                      <Stack spacing={2} direction="row">
                                        <TextField
                                          onChange={(e) =>
                                            handleChangeKeterangan(
                                              field.detailContentEstimateImpactId,
                                              null,
                                              e
                                            )
                                          }
                                          value={field.keterangan}
                                          name="keterangan"
                                          label="Keterangan"
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled={status === "issued"}
                                        />
                                        <IconButton
                                          color="primary"
                                          aria-label="upload picture"
                                          component="label"
                                          onClick={() =>
                                            handleRemove(
                                              field.detailContentEstimateImpactId,
                                              null
                                            )
                                          }
                                          disabled={status === "issued"}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Stack>
                                    </Grid>
                                  </>
                                )}

                                {/* List Field id 5 */}
                                {field.detailEstimateImpactId === 5 && (
                                  <>
                                    <Grid item xl={3} lg={3} sm={3} xs={12}>
                                      <p>
                                        {field.detailContentEstimateImpactName}
                                      </p>
                                    </Grid>

                                    <Grid item xl={9} lg={9} sm={9} xs={12}>
                                      <Stack spacing={2} direction="row">
                                        <TextField
                                          name="jumlahOrNilaiKerugian"
                                          onChange={(e) => {
                                            e.target.value =
                                              e.target.value.replaceAll(
                                                ".",
                                                ""
                                              );
                                            handleChangeInput(
                                              field.detailContentEstimateImpactId,
                                              null,
                                              e
                                            );
                                          }}
                                          value={formatCurrency(
                                            field.jumlahOrNilaiKerugian
                                          )}
                                          label="Nilai Kerugian"
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled={status === "issued"}
                                        />
                                        <TextField
                                          name="satuan"
                                          value={field.satuan}
                                          label="Satuan"
                                          InputLabelProps={{ shrink: true }}
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled
                                        />
                                        <TextField
                                          onChange={(e) =>
                                            handleChangeKeterangan(
                                              field.detailContentEstimateImpactId,
                                              null,
                                              e
                                            )
                                          }
                                          value={field.keterangan}
                                          name="keterangan"
                                          label="Keterangan"
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled={status === "issued"}
                                        />
                                        <IconButton
                                          color="primary"
                                          aria-label="upload picture"
                                          component="label"
                                          onClick={() =>
                                            handleRemove(
                                              field.detailContentEstimateImpactId,
                                              null
                                            )
                                          }
                                          disabled={status === "issued"}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Stack>
                                    </Grid>
                                  </>
                                )}

                                {/* List Field id 6 */}
                                {field.detailEstimateImpactId === 6 && (
                                  <>
                                    <Grid item xl={3} lg={3} sm={3} xs={12}>
                                      <p>
                                        {field.detailContentEstimateImpactName}
                                      </p>
                                    </Grid>

                                    <Grid item xl={9} lg={9} sm={9} xs={12}>
                                      <Stack spacing={2} direction="row">
                                        <TextField
                                          onChange={(e) =>
                                            handleChangeKeterangan(
                                              field.detailContentEstimateImpactId,
                                              null,
                                              e
                                            )
                                          }
                                          value={field.keterangan}
                                          name="keterangan"
                                          label="Keterangan"
                                          variant="standard"
                                          fullWidth
                                          type="text"
                                          disabled={status === "issued"}
                                        />
                                        <IconButton
                                          color="primary"
                                          aria-label="upload picture"
                                          component="label"
                                          onClick={() =>
                                            handleRemove(
                                              field.detailContentEstimateImpactId,
                                              null
                                            )
                                          }
                                          disabled={status === "issued"}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Stack>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                            )
                        )}

                      {/* Footer Field id 2 */}
                      {item.detailEstimateImpactId === 2 &&
                        totalEnvKonversi > 0 && (
                          <Grid
                            container
                            spacing={0}
                            key={item.detailEstimateImpactId}
                          >
                            <Grid item xl={1} lg={1} sm={1} xs={12}></Grid>

                            <Grid item xl={11} lg={11} sm={11} xs={12}>
                              <Stack spacing={2} direction="row">
                                <div style={{ width: "100%" }}></div>
                                <div style={{ width: "100%" }}></div>
                                <div style={{ width: "100%" }}></div>
                                <div style={{ width: "100%" }}></div>
                                <FormControl variant="standard" fullWidth>
                                  <TextField
                                    name="totalEnvKonversi"
                                    value={formatCurrency(totalEnvKonversi)}
                                    label={
                                      <Typography sx={{ fontWeight: "bold" }}>
                                        Total Konversi
                                      </Typography>
                                    }
                                    variant="standard"
                                    fullWidth
                                    disabled
                                  />
                                </FormControl>
                                <div
                                  style={{
                                    width: "100%",
                                  }}
                                ></div>
                              </Stack>
                            </Grid>
                          </Grid>
                        )}

                      {/* Footer field id 5 */}
                      {item.detailEstimateImpactId === 5 && totalAaE > 0 && (
                        <Grid
                          container
                          spacing={0}
                          key={item.detailEstimateImpactId}
                        >
                          <Grid item xl={1} lg={1} sm={1} xs={12}></Grid>

                          <Grid item xl={11} lg={11} sm={11} xs={12}>
                            <Stack spacing={2} direction="row">
                              <div style={{ width: "10%" }}></div>
                              <div style={{ width: "100%" }}></div>
                              <div style={{ width: "100%" }}></div>
                              <div style={{ width: "100%" }}></div>
                              <FormControl variant="standard" fullWidth>
                                <TextField
                                  name="totalEnvKonversi"
                                  value={formatCurrency(totalAaE)}
                                  label={
                                    <Typography sx={{ fontWeight: "bold" }}>
                                      Total Konversi
                                    </Typography>
                                  }
                                  inputProps={{
                                    style: { fontWeight: "bold" },
                                  }}
                                  variant="standard"
                                  fullWidth
                                  disabled
                                  style={{ fontWeight: "bold" }}
                                />
                              </FormControl>
                              <div style={{ width: "100%" }}></div>
                            </Stack>
                          </Grid>
                        </Grid>
                      )}
                      {/* Header Field id 3 */}
                      {item.detailEstimateImpactId === 3 &&
                        (totalEnvKonversi > 0 || totalAaE > 0) && (
                          <Grid
                            container
                            spacing={0}
                            key={item.detailEstimateImpactId + "header"}
                            sx={{
                              fontWeight: "bold",
                              marginTop: -3,
                            }}
                          >
                            Value BTR USD{" "}
                            {formatCurrency(inputFields.staticValueBTR)}
                          </Grid>
                        )}

                      {/* List Field id 3 */}
                      {item.detailEstimateImpactId === 3 &&
                        usedDetailEstimateContent?.map(
                          (field) =>
                            field.detailEstimateImpactId ===
                              item.detailEstimateImpactId && (
                              <Grid
                                container
                                spacing={0}
                                key={field.detailContentEstimateImpactId}
                              >
                                <Grid item xl={3} lg={3} sm={3} xs={12}>
                                  <p>{field.detailContentEstimateImpactName}</p>
                                </Grid>

                                <Grid item xl={9} lg={9} sm={9} xs={12}>
                                  <Stack spacing={2} direction="row">
                                    <TextField
                                      name="jumlahOrNilaiKerugian"
                                      label="Nilai Kerugian"
                                      value={formatCurrency(
                                        field.jumlahOrNilaiKerugian
                                      )}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      disabled
                                      variant="standard"
                                      fullWidth
                                      type="text"
                                    />
                                    <TextField
                                      name="satuan"
                                      value={field.satuan}
                                      disabled
                                      label="Satuan"
                                      InputLabelProps={{ shrink: true }}
                                      variant="standard"
                                      fullWidth
                                      type="text"
                                    />
                                    <TextField
                                      onChange={(e) =>
                                        handleChangeKeterangan(
                                          field.detailContentEstimateImpactId,
                                          null,
                                          e
                                        )
                                      }
                                      value={field.keterangan}
                                      name="keterangan"
                                      label="Keterangan"
                                      variant="standard"
                                      fullWidth
                                      type="text"
                                      disabled={status === "issued"}
                                    />
                                  </Stack>
                                </Grid>
                              </Grid>
                            )
                        )}

                      {/* Footer Field id 3 */}
                      {item.detailEstimateImpactId === 3 &&
                        (totalEnvKonversi > 0 || totalAaE > 0) && (
                          <>
                            <Grid
                              container
                              spacing={0}
                              key={item.detailEstimateImpactId}
                            >
                              <Grid
                                item
                                xl={3}
                                lg={3}
                                sm={3}
                                xs={12}
                                sx={{ fontWeight: "bold" }}
                              >
                                Total
                              </Grid>
                              <Grid item xl={9} lg={9} sm={9} xs={12}>
                                <Stack spacing={2} direction="row">
                                  <FormControl variant="standard" fullWidth>
                                    <TextField
                                      disabled
                                      value={formatCurrency(
                                        Number(
                                          totalAaE + totalEnvKonversi
                                        ).toFixed(0)
                                      )}
                                      variant="standard"
                                      fullWidth
                                      inputProps={{
                                        style: { fontWeight: "bold" },
                                      }}
                                    />
                                  </FormControl>
                                  <div style={{ width: "100%" }}></div>
                                  <div
                                    style={{
                                      width: "100%",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Financial Impact ={" "}
                                    {(
                                      ((totalAaE + totalEnvKonversi) /
                                        inputFields.staticValueBTR) *
                                      100
                                    ).toFixed(0)}
                                    % BTR
                                  </div>
                                </Stack>
                              </Grid>
                            </Grid>
                          </>
                        )}
                    </Box>
                  )}
                </div>
              ))}
          <br />

          {children}
        </Box>
      )}
    </div>
  );
};

export default EstimateImpact;
